export const language: any ={
    title: "Hey! Cooker Community",
    follow: "Follow",
    follower: "Followers",
    post_share: "Shared post",
    like_share: "Like",
    report: "Report violation",
    delete_post: "Delete post",
    delete_comment: "Delete comment",
    confirm_report: "Are you sure this post contains content that violates community guidelines? After a successful report, you will no longer see this post.",
    confirm_report_comment: "Are you sure this comment violates community guidelines?",
    toats_report: "Thank you for reporting the violation, your report is under review.",
    confirm_delete: "Do you want to delete this post?",
    confirm_delete_comment: "Are you sure you want to delete this comment?",
    toast_delete: "Successfully deleted!",
    text_yes: "Yes",
    text_no: "No",
    create: {
      title: "Create Post - Hey! Cooker Community",
      content_placeholder: "Enter your post content",
      submit: "Share it right away",
      add_image_by_camera: "Take a photo",
      add_image_by_gallery: "Choose an image",
      add_video_by_camera: "Record a video",
      add_video_by_gallery: "Choose a video",
    },
    detail: {
      shared: "Shared",
      shared_community: "Shared photo (video) with the community"
    },
    follwed: "Followed",
    comment: {
      placeholder: "Please enter the comment",
      submit: "Send",
      nodata: "Leave a comment here and become the first comment author!",
      load_more: "More comments",
      not_login: "Please log in to comment",
      delete: "Delete comment",
      delete_confirm: "Are you sure you want to delete this comment?",
      delete_success: "Comment deleted successfully",
      report: "Report",
      report_confirm: "Are you sure this comment violates community guidelines?",
      report_success: "Thank you for reporting,\nyour report is under review",
    },
    bottom_navigation: "Community",
    shared_post: "Shared the post"
}
